import { Map as ImmutableMap } from 'immutable';
import { EMAIL_CAMPAIGN } from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { getBaseEventBasedFilterFamilyField, getEventBasedFilterFamilyFields, getRefinementCondition } from '../strategy/eventBasedFilters';
import { useGetOperators } from './useGetOperators';
export const useMarketingEmailFilter = (condition, onChange) => {
  var _condition$field, _condition$field2;
  const {
    getRefinementOperators
  } = useGetOperators();
  const statusField = getBaseEventBasedFilterFamilyField(EMAIL_CAMPAIGN).set('metadata', {
    assetName: (_condition$field = condition.field) === null || _condition$field === void 0 ? void 0 : _condition$field.name,
    assetType: (_condition$field2 = condition.field) === null || _condition$field2 === void 0 ? void 0 : _condition$field2.type
  });
  const statusCondition = condition.set('field', statusField);
  const dateRefinementCondition = getRefinementCondition(EMAIL_CAMPAIGN, condition.dateRefinement);
  const getRefinementsWithEmptyValue = refinementFields => {
    return refinementFields.map(field => {
      const operators = getRefinementOperators(EMAIL_CAMPAIGN, field);
      return operators.first().of(field);
    });
  };
  const refinementFields = getEventBasedFilterFamilyFields(EMAIL_CAMPAIGN, ImmutableMap(), condition, true);
  const refinementConditionsEmptyValue = getRefinementsWithEmptyValue(refinementFields.toArray());
  const onStatusChange = marketingEmailStatusCondition => {
    const newCondition = condition.set('value', marketingEmailStatusCondition.get('value'));
    onChange(newCondition);
  };
  return {
    statusCondition,
    dateRefinementCondition,
    refinementConditionsEmptyValue,
    onStatusChange
  };
};